import { format, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { BsFillTrashFill, BsPencilSquare, BsSearch } from "react-icons/bs";
import { toast } from "react-toastify";
import Badge from "../../components/Badge";
import LoadingEffect from "../../components/LoadingEffect";
import ModalAtis from "../../components/ModalAtis";
import Popover from "../../components/Popover";
import SpecialEventPropose from "../../components/SpecialEventPropose";
import SpecialEventShow from "../../components/SpecialEventShow";
import { apiSpecialEvent } from "../../services/data";
import { Button, ButtonA } from "../../styles-components/Buttons";
import { Container, Section } from "../../styles-components/Container";
import { FormHeader } from "../../styles-components/FormItens";
import { DaysAgo, SubTitle } from "../../styles-components/Texts";
import SpecialEventStatus from "../../utils/PopoverMessages";
import UseRedirectView from "../../utils/UseRedirectView";
import {
  ButtonBadge,
  GroupButtons,
  Header,
  HeaderFilter,
  Info,
  SpecialEvent,
  Wrapper,
} from "./styles";

const ListSpecialEvent = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [filtredEvents, setFiltredEvents] = useState([]);
  const [canPropose, setCanPropose] = useState(false);
  const [id, setId] = useState(0);
  const [idForm, setIdForm] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [isFirst, setIsFirst] = useState(false);
  const [color, setColor] = useState('--black');

  const fetchData = () => {
    setIsLoading(true);
    apiSpecialEvent
      .index()
      .then((response) => {
        setEvents(response.data.data.events);
        setFiltredEvents(response.data.data.events);
        setCanPropose(response.data.data.can_propose);
        setIsLoading(false);
      })
      .catch(() => toast.error("Algo deu errado entre você e o servidor!"));
  };

  const handleDelete = useCallback(
    async (id) => {
      await apiSpecialEvent
        .destroy(id)
        .then((response) => {
          if (response.data.data && response.data.data.error) {
            toast.error(response.data.data.message);
          } else {
            setEvents((prev) => prev.filter((item) => item.id !== id));
            toast.success("Evento especial deletado com sucesso!");
          }
        })
        .catch(() => toast.error("Algo deu errado ao deletar!"));
    },
    [setEvents]
  );

  const handleOpenModal = useCallback(
    (id) => {
      setOpenModal(true);
      setId(id);
    },
    [setId, setOpenModal]
  );

  const handleOpenForm = useCallback(
    (id, type) => {
      setIsFirst(type);
      setIdForm(id);
      setOpenForm(true);
    },
    [setIdForm, setOpenForm]
  );

  const handleFilter = useCallback(
    (type, color) => {
      if (type !== "inativos") {
        setFiltredEvents(events.filter((item) => item.status === type));
      } else {
        setFiltredEvents(
          events.filter(
            (item) => item.status === "cancelado" || item.status === "rejeitado"
          )
        );
      }
      setColor(() => color);
    },
    [events, setFiltredEvents]
  );

  const handleRejectedEvent = useCallback(
    async (id) => {
      if (confirm("Deseja realmente rejeitar está evento?")) {
        await apiSpecialEvent
          .update(id, { only_status: true, status: "rejeitado" })
          .then(() => {
            toast.success("Evento rejeitado!");
            setId(0);
            fetchData();
          })
          .catch(() => toast.error("Algo deu errado entre você é o servidor!"));
      }
    },
    [fetchData, setId]
  );

  const handelCancelPropose = useCallback(
    async (id) => {
      await apiSpecialEvent
        .updateProposeCancel(id)
        .then((response) => {
          if (response.data.data && response.data.data.error) {
            toast.error(response.data.data.message);
          } else {
            fetchData();
            toast.success("Proposta deletada com sucesso!");
          }
        })
        .catch(() => toast.error("Algo deu errado ao cancelar a proposta!"));
    },
    [fetchData]
  );

  const handelRestoreEvent = useCallback(
    async (id) => {
      await apiSpecialEvent
        .restore(id)
        .then((response) => {
          if (response.data.data && response.data.data.error) {
            toast.error(response.data.data.message);
          } else {
            fetchData();
            toast.success("Evento restaurado com sucesso!");
          }
        })
        .catch(() => toast.error("Algo deu errado ao restaurar o evento!"));
    },
    [fetchData]
  );

  const handleNoFilter = useCallback((color) => {
    setFiltredEvents([...events]);
    setColor(() => color);
  }, [events, setFiltredEvents]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <Container>
          <ModalAtis onClose={() => setOpenModal(false)} show={openModal}>
            <SpecialEventShow
              id={id}
              onClose={() => setOpenModal(false)}
              setId={setId}
              updateData={fetchData}
            />
          </ModalAtis>
          <ModalAtis onClose={() => setOpenForm(false)} show={openForm}>
            <SpecialEventPropose
              id={idForm}
              onClose={() => setOpenForm(false)}
              setId={setIdForm}
              updateData={fetchData}
              isFirst={isFirst}
            />
          </ModalAtis>
          <FormHeader>
            <h1>Eventos Especiais</h1>
            {!canPropose && (
              <Button
                color="--white"
                backgroundColor="--orange"
                onClick={() =>
                  UseRedirectView.to("formulario/eventoespecial/create")
                }
              >
                Solicitar Evento
              </Button>
            )}
          </FormHeader>
          <Section>
            <HeaderFilter>
              <div>
                <ButtonBadge onClick={() => handleNoFilter("--black")}>
                  <Badge bgColor="--black">Todos</Badge>
                </ButtonBadge>
                <ButtonBadge onClick={() => handleFilter("aprovado", "--dark-green")}>
                  <Badge type="success">Aprovados</Badge>
                </ButtonBadge>
                <ButtonBadge onClick={() => handleFilter("Análise", "--blue")}>
                  <Badge type="info">
                    {canPropose ? "Para análise" : "Em análise"}
                  </Badge>
                </ButtonBadge>
                <ButtonBadge onClick={() => handleFilter("proposta", "--yellow")}>
                  <Badge type="warning">Proposta</Badge>
                </ButtonBadge>
                {canPropose && (
                  <ButtonBadge onClick={() => handleFilter("recusado", "--register-gray")}>
                    <Badge type="danger">Proposta Recusada</Badge>
                  </ButtonBadge>
                )}
                <ButtonBadge onClick={() => handleFilter("inativos", "--register-gray")}>
                  <Badge type="inative">Inativos</Badge>
                </ButtonBadge>
              </div>
            </HeaderFilter>
            <Wrapper>
              {filtredEvents.length > 0 ? (
                <>
                  {filtredEvents.map((event) => (
                    <React.Fragment key={event.id}>
                      <SpecialEvent>
                        <Info>
                          <Header>
                            <Popover
                              text={SpecialEventStatus(event.status)}
                              direction="row-reverse"
                              // icon={<AiOutlineQuestionCircle style={{ marginLeft: "5px" }} />}
                            >
                              <Badge type={event.badge}>{event.status}</Badge>
                            </Popover>

                            <DaysAgo>{event.updated_at_ago}</DaysAgo>
                          </Header>
                          <h4>{event.title}</h4>
                          <h6>{event.client.nome_fantasia}</h6>
                          {event.status !== "Análise" &&
                            event.status !== "rejeitado" && (
                              <>
                                <h5>
                                  {event.status === "proposta"
                                    ? "Proposta:"
                                    : event.status === "recusado"
                                    ? "Proposta"
                                    : "Acordo aceito:"}
                                </h5>
                                <p>
                                  Prazo de pagamento:{" "}
                                  {format(
                                    parseISO(event.payment_term),
                                    "d/MM/y"
                                  )}
                                </p>
                                <p>
                                  Prazo de confirmação:{" "}
                                  {format(
                                    parseISO(event.confirm_deadline),
                                    "d/MM/y"
                                  )}
                                </p>
                                <p>
                                  Valor unitário:{" "}
                                  {event.unitary_value.toLocaleString("pt-br", {
                                    style: "currency",
                                    currency: "BRL",
                                    minimumFractionDigits: 2,
                                  })}
                                </p>
                                {event.has_addition === 1 && (
                                  <p>
                                    Valor adicional:{" "}
                                    {event.addition_value.toLocaleString(
                                      "pt-br",
                                      {
                                        style: "currency",
                                        currency: "BRL",
                                        minimumFractionDigits: 2,
                                      }
                                    )}
                                  </p>
                                )}
                                <p>
                                  Valot total:{" "}
                                  {event.total_value.toLocaleString("pt-br", {
                                    style: "currency",
                                    currency: "BRL",
                                    minimumFractionDigits: 2,
                                  })}
                                </p>
                                <p>
                                  {event.has_service_selected ? (
                                    `NCM para faturamento: ${event.service_selected.produto_servico.ncm} | ${event.service_selected.produto_servico.nome}`
                                  ) : (
                                    <>
                                      Opções de NCM a definir por uma:
                                      {event.services.map((service) => (
                                        <React.Fragment
                                          key={service.produto_servico.nome}
                                        >
                                          <br />
                                          <span style={{ fontSize: "0.9rem" }}>
                                            {service.produto_servico.ncm +
                                              " | " +
                                              service.produto_servico.nome}
                                          </span>
                                        </React.Fragment>
                                      ))}
                                    </>
                                  )}
                                </p>
                              </>
                            )}
                          <section>
                            {(event.status === "Análise" ||
                              event.status === "recusado") &&
                              canPropose && (
                                <>
                                  <ButtonA
                                    type="button"
                                    onClick={() =>
                                      handleOpenForm(
                                        event.id,
                                        event.total_value ? false : true
                                      )
                                    }
                                  >
                                    {event.status === "recusado"
                                      ? "Nova"
                                      : "Efetuar"}{" "}
                                    proposta
                                  </ButtonA>
                                  <ButtonA
                                    type="button"
                                    onClick={() =>
                                      handleRejectedEvent(event.id)
                                    }
                                  >
                                    Rejeitar evento
                                  </ButtonA>
                                </>
                              )}
                            {(event.status === "proposta" ||
                              event.status === "recusado") &&
                              canPropose && (
                                <ButtonA
                                  type="button"
                                  onClick={() => handelCancelPropose(event.id)}
                                >
                                  Cancelar proposta
                                </ButtonA>
                              )}
                            {(event.status === "cancelado" ||
                              event.status === "rejeitado") &&
                              canPropose && (
                                <ButtonA
                                  type="button"
                                  onClick={() =>
                                    confirm(
                                      "Deseja mesmo restaurar esse evento? Ele voltará ao momento em que estavá antes de ser cancelado ou rejeitado"
                                    ) && handelRestoreEvent(event.id)
                                  }
                                >
                                  Restaurar evento
                                </ButtonA>
                              )}
                          </section>
                        </Info>
                        <GroupButtons>
                          {!canPropose && event.status === "Análise" && (
                            <>
                              <ButtonA
                                as={"button"}
                                color="--white"
                                backgroundColor="--red"
                                onClick={() =>
                                  confirm(
                                    "Deseja realmente excluir este evento?"
                                  ) && handleDelete(event.id)
                                }
                              >
                                <BsFillTrashFill />
                              </ButtonA>
                              <ButtonA
                                as={"button"}
                                color="--white"
                                backgroundColor="--yellow"
                                onClick={() =>
                                  UseRedirectView.to(
                                    `formulario/eventoespecial/${event.id}/edit`
                                  )
                                }
                              >
                                <BsPencilSquare />
                              </ButtonA>
                            </>
                          )}
                          <ButtonA
                            as={"button"}
                            color="--white"
                            backgroundColor="--blue-icon"
                            onClick={() => handleOpenModal(event.id)}
                          >
                            <BsSearch />
                          </ButtonA>
                        </GroupButtons>
                      </SpecialEvent>
                      <hr style={{ border: "0.5px dashed", color: `var(${color})` }} />
                    </React.Fragment>
                  ))}
                </>
              ) : (
                <SubTitle>Nenhum encontrado</SubTitle>
              )}
            </Wrapper>
          </Section>
        </Container>
      )}
    </>
  );
};

export default ListSpecialEvent;
